module.exports = __webpack_public_path__ + "img/instagram.a257c264.png";